/* global $, showAlertMsg */

(function () {
    function opCfg() {
        return window.__openPaymentAddConfig || {};
    }

    function opIsMemberSession() {
        return !!opCfg().isMemberSession;
    }

    function opHasPrefilledMember() {
        return !!opCfg().memberOpenPayment;
    }

    function opMemberUserId() {
        const v = opCfg().openPaymentMemberUserId;
        return v != null && v !== '' ? String(v) : null;
    }

    function opMinAmount() {
        return Number(opCfg().minAmount || 0);
    }

    function opModal() {
        return $('#addOpenPaymentModal');
    }

    /** Full-screen busy UI for Pay/Save; prefers shell overlay so it works when #mgr_index_paging has no #overlay. */
    function opBusyOverlay() {
        const $g = $('#mgr_global_overlay');
        return $g.length ? $g : $('#overlay');
    }

    let openPaymentDafCardType = 'credit';
    const savedPaymentsState = { cache: {}, inFlight: {}, lastUserId: null };

    function openPaymentSelectedUserId() {
        const prefilled = opMemberUserId();
        if (prefilled) {
            return String(prefilled);
        }
        return String($('#open_payment_user_id').val() || '');
    }

    function openPaymentHasMemberSelected() {
        const uid = openPaymentSelectedUserId();
        return $.isNumeric(parseInt(uid, 10));
    }

    function openPaymentCardChoiceValue() {
        return String($('#open_payment_payment_type').val() || '');
    }

    function openPaymentSetManualCcConstraints(opts) {
        const online = !!(opts && opts.online);
        const ptype = String((opts && opts.paymentType) || '');
        const isNew = online && ptype === 'new';

        if (!isNew) {
            if (typeof window.ccEntrySyncManualCcState === 'function') {
                window.ccEntrySyncManualCcState({
                    idPrefix: 'open_payment',
                    manualEnabled: false,
                    requireBaseManualFields: false,
                    requireZipAndCvv: false,
                });
            }
            return;
        }

        window.setOpenPaymentDafCardType(openPaymentDafCardType);
    }

    function openPaymentIsOnline() {
        if (opIsMemberSession()) {
            return true;
        }
        return opModal().find('input[name="open_payment_method"]:checked').val() === 'online';
    }

    function openPaymentSyncPaymentUiState() {
        const online = openPaymentIsOnline();
        const hasMember = openPaymentHasMemberSelected();
        const p = '#open_payment_';

        if (!opMemberUserId() && !opIsMemberSession()) {
            $(p + 'card_choice_saved,' + p + 'card_choice_new').prop('disabled', !hasMember);
            if (!hasMember) {
                $(p + 'saved_payment_id').prop('disabled', true).empty();
                $('#open_payment_payment_type').val('');
                $(p + 'card_choice_saved,' + p + 'card_choice_new')
                    .removeClass('mass_comm_active')
                    .addClass('dark_button');
                openPaymentEnableManualCc(false);
                $('#addOpenPaymentModal .save_pay_div').hide();
                $('#addOpenPaymentModal .open_pay_cc_manual').hide();
            }
        }

        const cardChoiceMade = openPaymentCardChoiceValue() === 'new' || openPaymentCardChoiceValue() === 'saved';
        const mustChooseCard = online && !cardChoiceMade;
        $('#open_payment_submit').prop('disabled', mustChooseCard);
    }

    function openPaymentSavedPaymentsUrl(uid) {
        const template = String(opCfg().savedPaymentsUrlTemplate || '');
        return template.replace(':user_id', String(uid));
    }

    function fetchOpenPaymentSavedPayments(uid) {
        const key = String(uid || '');
        if (!key) {
            return $.Deferred().resolve({ success: false, saved_cards: [] }).promise();
        }
        if (savedPaymentsState.cache[key]) {
            return $.Deferred().resolve(savedPaymentsState.cache[key]).promise();
        }
        if (savedPaymentsState.inFlight[key]) {
            return savedPaymentsState.inFlight[key];
        }

        const req = $.getJSON(openPaymentSavedPaymentsUrl(key))
            .then(function (res) {
                const normalized = (res && res.success)
                    ? { success: true, saved_cards: res.saved_cards || [] }
                    : { success: false, saved_cards: [] };
                savedPaymentsState.cache[key] = normalized;
                return normalized;
            })
            .catch(function () {
                const normalized = { success: false, saved_cards: [] };
                savedPaymentsState.cache[key] = normalized;
                return normalized;
            })
            .always(function () {
                delete savedPaymentsState.inFlight[key];
            });

        savedPaymentsState.inFlight[key] = req;
        return req;
    }

        window.setOpenPaymentDafCardType = function (cardType) {
            openPaymentDafCardType = cardType;
            const p = '#open_payment_';
            // Visual highlight is owned by the credit-card-entry component dispatcher; this
            // function only handles open-payment-specific side effects.
            if (cardType === 'credit') {
                const ptype = String($(p + 'payment_type').val() || '');
                const mustRequire = openPaymentIsOnline() && ptype === 'new';
                $(p + 'cvv2').prop('required', mustRequire);
                $(p + 'avs_zip').prop('required', mustRequire);
            } else {
                $(p + 'cvv2').prop('required', false);
                $(p + 'avs_zip').prop('required', false);
            }
        };

        window.dafCardTypeHandlers = window.dafCardTypeHandlers || {};
        window.dafCardTypeHandlers['open_payment_'] = window.setOpenPaymentDafCardType;

    function showOpenPaymentAjaxMsg(level, html) {
        const $box = $('#ajaxMsgOpenPayment');
        $box.removeClass('alert-danger alert-success alert-warning').addClass(level);
        $('#ajaxMsgOpenPaymentUl').html(html);
        $box.show();
    }

    function openPaymentEnableManualCc(enable) {
        const p = '#open_payment_';
        $(p + 'name,' + p + 'card,' + p + 'expiry_month,' + p + 'expiry_year,' + p + 'cvv2,' + p + 'avs_zip')
            .prop('disabled', !enable);
    }

    function openPaymentClearCcSection() {
        const p = '#open_payment_';
        $(p + 'payment_type').val('');
        $('#addOpenPaymentModal .payment_type_div').hide();
        $('#addOpenPaymentModal .save_pay_div').hide();
        $('#addOpenPaymentModal .open_pay_cc_manual').hide();
        $(p + 'name,' + p + 'card,' + p + 'expiry_month,' + p + 'expiry_year,' + p + 'cvv2,' + p + 'avs_zip')
            .val('')
            .prop('disabled', true);
        openPaymentSetManualCcConstraints({ online: false, paymentType: '' });
        $(p + 'saved_payment_id').prop('disabled', true).empty();
        $(p + 'card_choice_saved').removeClass('mass_comm_active').addClass('dark_button');
        $(p + 'card_choice_new').removeClass('mass_comm_active').addClass('dark_button');
        if (!opMemberUserId()) {
            $(p + 'card_choice_saved,' + p + 'card_choice_new').prop('disabled', true);
        } else {
            $(p + 'card_choice_saved,' + p + 'card_choice_new').prop('disabled', false);
        }
        window.setOpenPaymentDafCardType('credit');
        openPaymentSyncPaymentUiState();
    }

    function openPaymentPrepareOnlineCcShell() {
        $('#addOpenPaymentModal .payment_type_div').show();
        $('#addOpenPaymentModal .save_pay_div').hide();
        $('#addOpenPaymentModal .open_pay_cc_manual').hide();
        $('#open_payment_payment_type').val('');
        openPaymentEnableManualCc(false);
        openPaymentSetManualCcConstraints({ online: true, paymentType: '' });
        openPaymentSyncPaymentUiState();
    }

    function activateOpenPaymentNewCardUi() {
        const p = '#open_payment_';
        $(p + 'card_choice_saved,' + p + 'card_choice_new').removeClass('mass_comm_active').addClass('dark_button');
        $(p + 'payment_type').val('new');
        $('#addOpenPaymentModal .open_pay_cc_manual').show();
        $('#addOpenPaymentModal .save_pay_div').hide();
        $(p + 'saved_payment_id').prop('disabled', true).empty();
        $(p + 'card_choice_new').removeClass('dark_button').addClass('mass_comm_active');
        openPaymentEnableManualCc(true);
        window.setOpenPaymentDafCardType('credit');
        openPaymentSetManualCcConstraints({ online: true, paymentType: 'new' });
        openPaymentSyncPaymentUiState();
    }

    function syncMemberOpenPaymentSavedCardsOnShow() {
        const p = '#open_payment_';
        const muid = opMemberUserId();
        if (!muid) {
            return;
        }
        $('#open_payment_user_id').val(String(muid));
        openPaymentClearCcSection();
        openPaymentPrepareOnlineCcShell();
        $(p + 'card_choice_saved').prop('disabled', true);
        $(p + 'saved_payment_id').prop('disabled', true).empty();
        fetchOpenPaymentSavedPayments(muid).then(function (response) {
            const hasSaved = response.success && response.saved_cards && response.saved_cards.length > 0;
            if (!hasSaved) {
                $(p + 'card_choice_saved').prop('disabled', true);
                activateOpenPaymentNewCardUi();
                return;
            }
            $(p + 'card_choice_saved').prop('disabled', false);
            openPaymentSyncPaymentUiState();
        });
    }

    function syncOpenPaymentForceSurchargeBanner() {
        const $banner = $('#open_payment_force_surcharge_banner');
        const $text = $('#open_payment_force_surcharge_banner_text');
        if (!$banner.length || !$text.length) {
            return;
        }
        const titles = opCfg().openPaymentForceSurchargeTitles || [];
        const pct = String(opCfg().coverSurchargePercentDisplay || '').trim();
        if (!titles.length || !pct || !opCfg().coverSurchargeOn || !openPaymentIsOnline()) {
            $banner.addClass('d-none');
            return;
        }
        const camp =
            titles.length === 1
                ? titles[0]
                : titles.slice(0, -1).join(', ') + ' and ' + titles[titles.length - 1];
        $text.text(
            'A ' +
                pct +
                '% processing fee will be added to pledges paid by card for ' +
                camp +
                '. Use the checkbox below if you would like to cover processing costs on this credit purchase.'
        );
        $banner.removeClass('d-none');
    }

    function toggleOpenPaymentLayout() {
        const online = openPaymentIsOnline();
        const $resize = $('#open_payment_modal_resize');
        const $right = $('#open_payment_right_col');
        const $descriptionLabel = $('#open_payment_description_label');

        if (online) {
            $resize.removeClass('modal-sm').addClass('modal-lg');
            $('#open_payment_left_col').removeClass('col-12').addClass('col-md-12 col-lg-6');
            $right.show();
            $descriptionLabel.text('Notes');
            $('#open_payment_submit').text('Pay');
            openPaymentPrepareOnlineCcShell();
        } else {
            $resize.removeClass('modal-lg').addClass('modal-sm');
            $('#open_payment_left_col').removeClass('col-lg-6').addClass('col-12');
            $right.hide();
            $descriptionLabel.text('Notes / Check #');
            openPaymentClearCcSection();
            $('#open_payment_submit').text('Save');
        }

        openPaymentSetManualCcConstraints({ online: online, paymentType: openPaymentCardChoiceValue() });
        openPaymentSyncPaymentUiState();
        syncOpenPaymentForceSurchargeBanner();
    }

    function openPaymentValidateCardForm() {
        const p = '#open_payment_';
        const month = parseInt($(p + 'expiry_month').val(), 10);
        if (month > 12 || month < 1) {
            showOpenPaymentAjaxMsg('alert-danger', '<li>Invalid month (1–12).</li>');
            return false;
        }
        const nowYr = new Date().getFullYear() % 100;
        if ($(p + 'expiry_year').val() < nowYr) {
            showOpenPaymentAjaxMsg('alert-danger', '<li>Invalid year.</li>');
            return false;
        }
        if (openPaymentDafCardType === 'credit') {
            const digits = $(p + 'card').val().replace(/ /g, '');
            const cvvLen = $(p + 'cvv2').val().length;
            if (digits.substring(0, 1) !== '3') {
                if (digits.length !== 16 || cvvLen !== 3) {
                    showOpenPaymentAjaxMsg('alert-danger', '<li>Invalid card or CVV.</li>');
                    return false;
                }
            } else {
                if (digits.length !== 15 || cvvLen !== 4) {
                    showOpenPaymentAjaxMsg('alert-danger', '<li>Invalid Amex card or CVV.</li>');
                    return false;
                }
            }
            if (!/^((\d{5}-\d{4})|(\d{5})|([A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d))$/.test($(p + 'avs_zip').val())) {
                showOpenPaymentAjaxMsg('alert-danger', '<li>Please enter a valid US or Canadian postal code.</li>');
                return false;
            }
        }
        return true;
    }

    function openPaymentDestroyDatepickerIfAny() {
        const $dp = $('#open_payment_datepicker');
        if ($dp.length && $dp.data('datepicker')) {
            $dp.datepicker('destroy');
        }
    }

    function openPaymentInitDatepicker() {
        const $dp = $('#open_payment_datepicker');
        if (!$dp.length) {
            return;
        }
        openPaymentDestroyDatepickerIfAny();
        $dp.datepicker({
            autoclose: true,
            todayHighlight: false,
            endDate: '0d',
            clearBtn: false,
            orientation: 'top',
            format: 'mm/dd/yyyy',
        });
        const today = new Date();
        const formatted = (today.getMonth() + 1).toString().padStart(2, '0') + '/' +
            today.getDate().toString().padStart(2, '0') + '/' + today.getFullYear();
        $('#open_payment_date').val(formatted);
        $dp.datepicker('setDate', formatted);
    }

    function openPaymentApplyKioskInputMasks() {
        if (opCfg().kioskValidated) {
            return;
        }
        opModal().find('.open-payment-amount-input').prop({ type: 'number' });
        if ($('#open_payment_cvv2').length) {
            $('#open_payment_cvv2').inputmask('999[9]');
            $('#open_payment_expiry_month').inputmask('9[9]');
            $('#open_payment_expiry_year').inputmask('99');
        }
    }

    function bindOpenPaymentAddModalEvents() {
        $(document).off('change.openPayAddMethod', '#addOpenPaymentModal input[name="open_payment_method"]');
        $(document).on('change.openPayAddMethod', '#addOpenPaymentModal input[name="open_payment_method"]', function () {
            if (opIsMemberSession()) {
                return;
            }
            $(this).closest('.btn-group').find('label').removeClass('active');
            $(this).closest('label').addClass('active');
            toggleOpenPaymentLayout();
        });

        $(document).off('shown.bs.modal.openPayAdd', '#addOpenPaymentModal');
        $(document).on('shown.bs.modal.openPayAdd', '#addOpenPaymentModal', function () {
            if (opHasPrefilledMember()) {
                syncMemberOpenPaymentSavedCardsOnShow();
                openPaymentSyncPaymentUiState();
            }

            const $openPayUserSel = $('#open_payment_user_id');
            if ($openPayUserSel.length && $openPayUserSel.data('select2')) {
                $openPayUserSel.select2('destroy');
            }
            if ($openPayUserSel.length) {
                if (!opHasPrefilledMember() && !opIsMemberSession()) {
                    $openPayUserSel.select2({
                        theme: 'bootstrap-5',
                        containerCssClass: 'select2--medium',
                        selectionCssClass: 'select2--medium',
                        dropdownCssClass: 'select2--medium',
                        dropdownParent: opModal(),
                        width: '100%',
                        allowClear: false,
                        minimumResultsForSearch: 0,
                        placeholder: 'Select member',
                        templateResult: function (data) {
                            if (!data.element) {
                                return data.text;
                            }
                            const $w = $('<span></span>');
                            $w.addClass($(data.element)[0].className);
                            $w.text(data.text);
                            return $w;
                        },
                    });
                }
            }

            openPaymentSyncPaymentUiState();
            syncOpenPaymentForceSurchargeBanner();
        });

        $(document).off('show.bs.modal.openPayAdd', '#addOpenPaymentModal');
        $(document).on('show.bs.modal.openPayAdd', '#addOpenPaymentModal', function () {
            if (openPaymentIsOnline()) {
                openPaymentPrepareOnlineCcShell();
            }
            openPaymentSyncPaymentUiState();
            syncOpenPaymentForceSurchargeBanner();
        });

        $(document).off('change.openPayAddUser', '#open_payment_user_id');
        $(document).on('change.openPayAddUser', '#open_payment_user_id', function () {
            if (opHasPrefilledMember() || opIsMemberSession()) {
                return;
            }
            const isOnline = openPaymentIsOnline();
            if (!isOnline) {
                openPaymentSyncPaymentUiState();
                return;
            }

            const uid = $(this).val();
            const p = '#open_payment_';

            openPaymentClearCcSection();
            openPaymentPrepareOnlineCcShell();

            $(p + 'card_choice_saved').prop('disabled', true);
            $(p + 'saved_payment_id').prop('disabled', true).empty();

            $(p + 'card_choice_new').prop('disabled', !uid);
            if (!uid) {
                openPaymentSyncPaymentUiState();
                return;
            }

            $('#ajaxMsgOpenPayment').hide();

            fetchOpenPaymentSavedPayments(uid).then(function (response) {
                if (!response.success || !(response.saved_cards || []).length) {
                    openPaymentSyncPaymentUiState();
                    return;
                }
                $(p + 'saved_payment_id').empty();
                response.saved_cards.forEach(function (result) {
                    let addOn = result.default === 1 ? ' (Default)' : '';
                    if (result.use_otp === 1) {
                        addOn += ' (OTP from member required)';
                    }
                    $(p + 'saved_payment_id').append($('<option>', { value: result.id }).text(result.cc_info + addOn));
                });

                $(p + 'saved_payment_id').prop('disabled', false);
                $(p + 'card_choice_saved').prop('disabled', false);
                openPaymentSyncPaymentUiState();
            });
        });

        $(document).off('click.openPayAddCardChoice', '#addOpenPaymentModal input[name="open_payment_card_choice_button"]');
        $(document).on('click.openPayAddCardChoice', '#addOpenPaymentModal input[name="open_payment_card_choice_button"]', function () {
            const p = '#open_payment_';
            if ($(p + 'card_choice_saved').prop('disabled') && this.value !== 'Use new card') {
                return;
            }
            $(p + 'card_choice_saved,' + p + 'card_choice_new').removeClass('mass_comm_active').addClass('dark_button');
            if (this.value === 'Use new card') {
                activateOpenPaymentNewCardUi();
                return;
            }

            const uid = $('#open_payment_user_id').val();
            if (!uid) {
                showOpenPaymentAjaxMsg('alert-danger', '<li>Please select a member first.</li>');
                openPaymentSyncPaymentUiState();
                return;
            }

            fetchOpenPaymentSavedPayments(uid).then(function (response) {
                if (!response.success || !(response.saved_cards || []).length) {
                    showOpenPaymentAjaxMsg('alert-danger', '<li>No saved cards found for this user.</li>');
                    $(p + 'card_choice_saved').prop('disabled', true);
                    openPaymentSyncPaymentUiState();
                    return;
                }

                $(p + 'saved_payment_id').empty();
                response.saved_cards.forEach(function (result) {
                    let addOn = result.default === 1 ? ' (Default)' : '';
                    if (result.use_otp === 1) {
                        addOn += ' (OTP from member required)';
                    }
                    $(p + 'saved_payment_id').append($('<option>', { value: result.id }).text(result.cc_info + addOn));
                });

                $(p + 'saved_payment_id').prop('disabled', false);
                $(p + 'payment_type').val('saved');
                $('#addOpenPaymentModal .open_pay_cc_manual').hide();
                $('#addOpenPaymentModal .save_pay_div').show();
                $(p + 'card_choice_saved').removeClass('dark_button').addClass('mass_comm_active');
                openPaymentEnableManualCc(false);
                openPaymentSetManualCcConstraints({ online: true, paymentType: 'saved' });
                openPaymentSyncPaymentUiState();
            });
        });
    }

    $(document).ready(function () {
        bindOpenPaymentAddModalEvents();

        $(document).off('select2:open.openPayAdd', '#open_payment_user_id');
        $(document).on('select2:open.openPayAdd', '#open_payment_user_id', function () {
            if (opCfg().kioskValidated || opHasPrefilledMember() || opIsMemberSession()) {
                return;
            }
            setTimeout(function () {
                const searchField = document.querySelector('#open_payment_user_id + .select2-container .select2-search__field');
                if (searchField) {
                    searchField.focus();
                }
            }, 100);
        });

        if ($('#addOpenPaymentModal').length) {
            openPaymentInitDatepicker();
            if (!opCfg().coverSurchargeOn) {
                $('#addOpenPaymentModal .surcharge_row').hide();
            }
            toggleOpenPaymentLayout();
            openPaymentApplyKioskInputMasks();
        }
    });

    window.openPaymentAddModalWireUp = function () {
        savedPaymentsState.cache = {};
        savedPaymentsState.inFlight = {};
        savedPaymentsState.lastUserId = null;
        if (!$('#addOpenPaymentModal').length) {
            return;
        }
        openPaymentInitDatepicker();
        if (!opCfg().coverSurchargeOn) {
            $('#addOpenPaymentModal .surcharge_row').hide();
        } else {
            $('#addOpenPaymentModal .surcharge_row').show();
        }
        toggleOpenPaymentLayout();
        syncOpenPaymentForceSurchargeBanner();
        openPaymentApplyKioskInputMasks();
        $('#ajaxMsgOpenPayment').hide();
    };

    $(document).off('input.openPayAddCard', '#open_payment_card');
    $(document).on('input.openPayAddCard', '#open_payment_card', function () {
        const last = $(this).val().slice(-1);
        if (isNaN(last)) {
            $(this).val($(this).val().slice(0, -1));
            return;
        }
        const amexTest = $(this).val().replace(/\s/g, '');
        if (amexTest.match(/^3[47]\d{2}/)) {
            $(this).val(
                amexTest
                    .replace(/(\d{4})\s*(\d{6})?\s*(\d{5})?/, '$1 $2 $3')
                    .replace(/\s\s/g, ' ')
                    .trim()
                    .substring(0, 17),
            );
        } else {
            $(this).val(amexTest.replace(/(\d{4})(?=\d)/g, '$1 '));
        }
    });

    $(document).off('submit.openPayAddForm', '#validOpenPayment');
    $(document).on('submit.openPayAddForm', '#validOpenPayment', function (e) {
        e.preventDefault();

        const openPaymentPostUrl = String(opCfg().postUrl || '');
        const csrfToken = String(opCfg().csrfToken || '');
        const tokenUrl = String(opCfg().tokenUrl || '');
        const gatewayApi = String(opCfg().gatewayApi || '');
        const minAmount = opMinAmount();

        if (!openPaymentPostUrl) {
            showOpenPaymentAjaxMsg('alert-danger', '<li>Payment API is not configured.</li>');
            return false;
        }

        $('#ajaxMsgOpenPayment').hide();
        const online = openPaymentIsOnline();
        const uid = $('#open_payment_user_id').val();
        if (!uid) {
            showOpenPaymentAjaxMsg('alert-danger', '<li>Please select a member.</li>');
            return false;
        }
        const paymentDate = String($('#open_payment_date').val() || '').trim();
        if (!paymentDate) {
            showOpenPaymentAjaxMsg('alert-danger', '<li>Please select a payment date.</li>');
            return false;
        }

        function parseAmount(raw) {
            const n = parseFloat(String(raw || '').replace(/,/g, '').trim());
            return Number.isFinite(n) ? n : NaN;
        }

        const $amountInputs = opModal().find('.open-payment-amount-input');
        const multipleGateways = $amountInputs.length > 1;
        let amount = NaN;
        let amounts = null;

        if (!multipleGateways) {
            amount = parseAmount($('#open_payment_amount').val());
            if (isNaN(amount) || amount < minAmount) {
                showOpenPaymentAjaxMsg('alert-danger', '<li>The minimum amount is $' + minAmount.toFixed(2) + '.</li>');
                return false;
            }
        } else {
            amounts = {};
            let any = false;
            let hasInvalid = false;

            $amountInputs.each(function () {
                const $inp = $(this);
                const gid = parseInt(String($inp.data('gateway-id') || '0'), 10);
                const title = String($inp.data('gateway-title') || '').trim();
                const val = parseAmount($inp.val());

                if (!gid) {
                    return;
                }
                if ($inp.val() === '' || $inp.val() === null || typeof $inp.val() === 'undefined') {
                    return;
                }
                if (!Number.isFinite(val) || val < 0) {
                    hasInvalid = true;
                    return;
                }
                if (val === 0) {
                    return;
                }
                if (val < minAmount) {
                    hasInvalid = true;
                    const label = title ? String(title).replace(/</g, '&lt;').replace(/>/g, '&gt;') : 'a gateway';
                    showOpenPaymentAjaxMsg('alert-danger', '<li>The minimum amount for ' + label + ' is $' + minAmount.toFixed(2) + '.</li>');
                    return false;
                }

                any = true;
                amounts[String(gid)] = val;
            });

            if (hasInvalid) {
                if ($('#ajaxMsgOpenPayment').is(':hidden')) {
                    showOpenPaymentAjaxMsg('alert-danger', '<li>Please enter valid amounts.</li>');
                }
                return false;
            }
            if (!any) {
                showOpenPaymentAjaxMsg('alert-danger', '<li>Please enter at least one amount.</li>');
                return false;
            }
        }

        const $singleAmountInput = opModal().find('.open-payment-amount-input').first();
        const singleGatewayId = parseInt(String($singleAmountInput.data('gateway-id') || '0'), 10);

        const basePayload = {
            user_id: uid,
            amount: multipleGateways ? undefined : amount,
            amounts: multipleGateways ? amounts : undefined,
            gateway_id: multipleGateways ? undefined : (singleGatewayId > 0 ? singleGatewayId : undefined),
            payment_date: paymentDate,
            description: $('#open_payment_description').val(),
            open_payment_method: online ? 'online' : 'check_cash',
            offline_payment_notes: $('#open_payment_description').val(),
            _token: csrfToken,
        };

        if (!online) {
            opBusyOverlay().fadeIn();
            $.post(openPaymentPostUrl, basePayload)
                .done(function (res) {
                    opBusyOverlay().fadeOut();
                    if (res.success) {
                        showAlertMsg(res.success_msg || 'Open payment recorded.');
                        window.closeOpenPaymentModal({ action: 'submit' });
                    } else {
                        showOpenPaymentAjaxMsg('alert-danger', '<li>' + (res.error || 'Unable to save.') + '</li>');
                    }
                })
                .fail(function (xhr) {
                    opBusyOverlay().fadeOut();
                    const err = xhr.responseJSON && xhr.responseJSON.error ? xhr.responseJSON.error : 'Request failed.';
                    showOpenPaymentAjaxMsg('alert-danger', '<li>' + err + '</li>');
                });
            return false;
        }

        const p = '#open_payment_';
        const ptype = $(p + 'payment_type').val();
        if (!ptype) {
            showOpenPaymentAjaxMsg('alert-danger', '<li>Choose saved card or new card.</li>');
            return false;
        }
        if (ptype === 'new' && !openPaymentValidateCardForm()) {
            return false;
        }

        opBusyOverlay().fadeIn();

        const coverSaved = $(p + 'cover_surcharge_saved').prop('checked');
        const coverManual = $(p + 'cover_surcharge_manual').prop('checked');
        const saveCard = !!$(p + 'save_card').prop('checked');
        const useOtp = !!$(p + 'use_otp').prop('checked');

        function postOpenPayment(extra) {
            $.post(openPaymentPostUrl, Object.assign({}, basePayload, extra))
                .done(function (res) {
                    opBusyOverlay().fadeOut();
                    if (res.success) {
                        showAlertMsg('Payment processed successfully.');
                        window.closeOpenPaymentModal({ action: 'submit' });
                    } else {
                        showOpenPaymentAjaxMsg('alert-danger', '<li>' + (res.error || 'Payment failed.') + '</li>');
                    }
                })
                .fail(function (xhr) {
                    opBusyOverlay().fadeOut();
                    const err = xhr.responseJSON && xhr.responseJSON.error ? xhr.responseJSON.error : 'Request failed.';
                    showOpenPaymentAjaxMsg('alert-danger', '<li>' + err + '</li>');
                });
        }

        if (ptype === 'saved') {
            const ccId = $(p + 'saved_payment_id').val();
            if (!ccId) {
                showOpenPaymentAjaxMsg('alert-danger', '<li>Select a saved card.</li>');
                return false;
            }
            postOpenPayment({
                payment_type: 'saved',
                process_type: 'token',
                cc_id: ccId,
                cover_surcharge: coverSaved ? 'true' : 'false',
                cover_surcharge_saved: coverSaved ? 'true' : 'false',
            });
            return false;
        }

        const ccPayload = {
            payment_type: 'new',
            name: $(p + 'name').val(),
            maskedCard: $(p + 'card').val().slice(-4),
            expiryMonth: $(p + 'expiry_month').val(),
            expiryYear: '20' + $(p + 'expiry_year').val(),
            cvv2: $(p + 'cvv2').val(),
            avs_zip: $(p + 'avs_zip').val(),
            use_otp: useOtp,
            cover_surcharge: coverManual ? 'true' : 'false',
            cover_surcharge_manual: coverManual ? 'true' : 'false',
            save_card: saveCard,
            daf_card_type: openPaymentDafCardType,
        };

        if (openPaymentDafCardType === 'credit') {
            const body = {
                card: $(p + 'card').val().replace(/ /g, ''),
                cvv2: $(p + 'cvv2').val().replace(/_/g, ''),
            };

            fetch(tokenUrl, {
                method: 'POST',
                headers: {
                    Authorization: 'Basic ' + btoa(gatewayApi + ':'),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })
                .then((r) => r.json())
                .then((data) => {
                    if (data.nonce_token === undefined) {
                        opBusyOverlay().fadeOut();
                        showOpenPaymentAjaxMsg('alert-danger', '<li>' + (data.error_message || 'Card error') + '</li>');
                        return;
                    }
                    postOpenPayment(Object.assign({}, ccPayload, {
                        process_type: 'nonce',
                        nonce: data.nonce_token,
                    }));
                })
                .catch(function () {
                    opBusyOverlay().fadeOut();
                    showOpenPaymentAjaxMsg('alert-danger', '<li>Could not tokenize card.</li>');
                });
        } else {
            postOpenPayment(Object.assign({}, ccPayload, {
                process_type: 'direct',
                nonce: '',
                daf_card: $(p + 'card').val().replace(/ /g, ''),
            }));
        }

        return false;
    });

    window.closeOpenPaymentModal = function (opts) {
        const action = (opts && typeof opts === 'object' && opts.action) ? String(opts.action) : 'cancel';
        const $form = $('#validOpenPayment');
        if ($form.length && $form[0]) {
            $form[0].reset();
        }
        const muid = opMemberUserId();
        if (muid) {
            $('#open_payment_user_id').val(String(muid));
        } else {
            $('#open_payment_user_id').val(null).trigger('change');
        }
        $('#open_payment_payment_type').val('');
        openPaymentClearCcSection();
        $('#ajaxMsgOpenPayment').hide();
        if (!opIsMemberSession()) {
            $('#open_pay_online').prop('checked', true);
            $('#open_pay_offline').prop('checked', false);
            $('#open_pay_online').closest('label').addClass('active');
            $('#open_pay_offline').closest('label').removeClass('active');
        }
        toggleOpenPaymentLayout();

        const today = new Date();
        const formatted = (today.getMonth() + 1).toString().padStart(2, '0') + '/' +
            today.getDate().toString().padStart(2, '0') + '/' + today.getFullYear();
        $('#open_payment_date').val(formatted);
        const $dpClose = $('#open_payment_datepicker');
        if ($dpClose.length && $dpClose.data('datepicker')) {
            $dpClose.datepicker('setDate', formatted);
        }

        opModal().modal('hide');
        $('.modal-backdrop').remove();

        if (action !== 'submit') {
            return;
        }

        const after = opCfg().afterClose;
        const uid = opMemberUserId() || String($('#open_payment_user_id').val() || '');
        if (after === 'openCredits' && uid && typeof viewMemberOpenCreditDetails === 'function') {
            viewMemberOpenCreditDetails(uid);
        } else if (after === 'members' && typeof OpenMembersPage === 'function') {
            OpenMembersPage();
        } else if (after === 'pledges' && typeof OpenPledgesPage === 'function') {
            OpenPledgesPage();
        } else if (after === 'acctPayment' && typeof openAcctPayment === 'function') {
            openAcctPayment();
        } else if (after === 'none') {
            /* no reload */
        } else if (typeof OpenPledgesPage === 'function') {
            OpenPledgesPage();
        } else if (typeof OpenMyPledges === 'function') {
            OpenMyPledges();
        }
    };
})();

